import { useDataSubmit, useDataChange, useDataValue } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let bulk_task_ids = useDataValue({
    context: 'selected',
    path: 'bulk_task_ids',
    viewPath: props.viewPath,
  })

  let priority_id = useDataValue({
    context: 'priority',
    path: 'id',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'selected',
    path: 'bulk_task_ids',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({
      type: 'set_bulk_tasks_priority',
      task_and_priorities: bulk_task_ids.map(task => ({
        id: task,
        priority: priority_id,
      })),
    })

    change([])
  }
}
